export const parseUrlQuerySearchTerm = (input: string | undefined): string => {
  if (!input) return ''
  try {
    return decodeURIComponent(input.replace(/\+/g, ' ')).trim()
  } catch {
    return input.replace(/\+/g, ' ').trim()
  }
}
